import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js'
import { Space } from 'antd'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useMemo, useState } from 'react'

type ElementType = 'cardNumber' | 'cardCvc' | 'cardExpiry'

const colors = {
  primary: '#36707a',
  text: '#21393f',
  secondary: '#fd6565',
  white: '#ffffff',
  borderColor: '#e8e8e8',
  gray: '#bfbfbf'
}

const fontSize = '14px'

const style = {
  base: {
    iconColor: colors.text,
    color: colors.text,
    fontWeight: 400,
    fontSize,
    lineHeight: '1.5715',
    '::placeholder': {
      color: colors.gray
    }
  },
  invalid: {
    iconColor: colors.secondary,
    color: colors.secondary
  }
}

const classes = { base: 'ant-input ant-input-lg' }

const Element = ({ type }: { type: ElementType }) => {
  const [error, setError] = useState('')
  const { tAttribute } = ToolBox.useString()

  const label = useMemo(
    () => tAttribute({ attribute: type, recordType: RecordType.credit_card }),
    []
  )

  const onChange = ({ error }: { error: { message: string } }) => {
    setError(error?.message)
  }

  return (
    <Space direction="vertical" className="full-width px-1" size={0}>
      <div className="ant-form-item-label">
        <label title="Card Details">{label}</label>
      </div>
      <div className={'custom-card-element'}>
        <Choose>
          <When condition={type === 'cardNumber'}>
            <CardNumberElement options={{ style, classes }} onChange={onChange} />
          </When>
          <When condition={type === 'cardExpiry'}>
            <CardExpiryElement options={{ style, classes }} onChange={onChange} />
          </When>
          <When condition={type === 'cardCvc'}>
            <CardCvcElement options={{ style, classes }} onChange={onChange} />
          </When>
        </Choose>
      </div>
      <If condition={error}>
        <span className="text-secondary fade-in-slow">{error}</span>
      </If>
    </Space>
  )
}

export default Element
